/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { REGEX_ACCOUNT } from "../../util/RegEx";
import { Grid, TextField, MenuItem, InputAdornment, IconButton, List, ListItem, ListItemText, Button  } from "@mui/material";
import { DialogActions, DialogContent, Dialog, DialogTitle } from "@mui/material";
import { Close, GroupAdd } from "@mui/icons-material";
import { version } from "../../util/DataObject";
import { styled } from '@mui/material/styles';
import { ModalStyle } from "../../util/Styles";
import moment from 'moment';
import 'moment/locale/es';

const FireNav = styled(List)({
  '& .MuiListItem-root': {
    padding: 0,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
    marginRight: 16,
  },
});

const AssignAgreement = (props) => {
  const [zPos, setZPos] = useState(45)
  const history = useHistory();
  const [disabled, setDisabled] = useState(true);
  const [signed, setSigned] = useState([]);
  const [form, setForm] = useState({
    version: "",
    customer_uuid: "",
    space_uuid: "",
    account_number: "",
    signing_date: moment(new Date()).format().slice(0, 16),
    signed_by: [],
  });

  const [error, setError] = useState({
    version: "",
    customer_uuid: "",
    space_uuid: "",
    account_number: "",
    signing_date: "",
    signed_by: "",
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {};
  
  const change = async (field, e) => {
    let f = form;
    let er = error;
    
    if (!e.target.value) {
      er[field] = "Dato obligatorio";
    } else {
      er[field] = "";
    }

    f[field] = e.target.value;

    if(field == 'account_number'){
      if(!REGEX_ACCOUNT.test(e.target.value)){        
        er['account_number'] = "Cuenta Inválida";
      } else {       
        er['account_number'] = "";
      }
    }

    validate(f, er)
    setError(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const validate = async (f, er) => {
    if((f['version'] && f['customer_uuid'] && f['space_uuid'] && signed.length > 0 && f['signing_date']) && (!er['version'] && !er['customer_uuid'] && !er['space_uuid']) && !er['account_number'] && !er['signing_date'] && !er["signed_by"]){
      setDisabled(false);
    }else{
      setDisabled(true);
    }
  }
  const addSigner = async (name) => {    
    let sign = signed
    let f = form;
    sign.push(name)
    f["signed_by"] = []

    validate(f, error)
    setSigned(JSON.parse(JSON.stringify(sign)))
    setForm(JSON.parse(JSON.stringify(f)));
  }

  const deleteSigner = async (name) => {  
    let sign = signed
    let er = error;
    let newList = sign.filter(i => i !== name)

    if(newList.length === 0 ){
      er["signed_by"] = "Dato obligatorio";
    } else {
      er["signed_by"] = "";
    }
    
    validate(form, er)
    setSigned(JSON.parse(JSON.stringify(newList)))
  }
  
  const create = async () => {
    props.changeLoader(true);
    setZPos(-1)

    let data = form;
    let er = error;
    data["signed_by"] = signed
    let spaceOK, accountOK = false

    
    let request = await API.service( "cuentas", data["customer_uuid"], props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        request.data.data.widget[1].data.content.map((i) => {
          i.uuid == data["space_uuid"] ? spaceOK = true : er['space_uuid'] = "Espacio inválido" 
          i.accountNumber == data["account_number"] ? accountOK = true : er['account_number'] = "Cuenta inválida"
          validate(form, er)
          setError(JSON.parse(JSON.stringify(er)));    
        })
      } else {
        er['customer_uuid'] = "Identificador inválido.";
        validate(form, er)
        setError(JSON.parse(JSON.stringify(er)));
      }
    }
    
    if(spaceOK && accountOK){
      data["signing_date"] = new Date(data["signing_date"]).toJSON().replace('T', ' ')
      let response = await API.service( "assignAgreement", data, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Registro generado con éxito");
          closelightbox();
        } else {
          let detail = response.data.data.message;
          props.changeAlert(true, "error", "Error al generar registro. " + detail);
        }
      }
    }

    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle style={{marginBottom: "0"}} >
          <span>
            Registro de Contrato
            <p id="subtitle_2">Registro en sistema de contrato dado de alta en repositorio S3 de AFB </p>
          </span>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginBottom: "10px" }}>
            <Grid item xs={6}>
              <TextField
                label="Version" value={form.version} onChange={change.bind(this, "version")} select error={error.version !== ""} helperText={error.version ? error.version : ''} size="small" fullWidth >
                {version?.map((i) => (
                  <MenuItem key={i.key} value={i.key}>{i.label}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Identificador del Cliente" value={form.customer_uuid} onChange={change.bind(this, "customer_uuid")} error={error.customer_uuid !== ""} helperText={error.customer_uuid ? error.customer_uuid : ''} inputProps={{style: { width: "100%", textAlign: "inherit" }}} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Identificador del Espacio" value={form.space_uuid} onChange={change.bind(this, "space_uuid")} error={error.space_uuid !== ""} helperText={error.space_uuid ? error.space_uuid : ''} inputProps={{style: { width: "100%", textAlign: "inherit" }}} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Número de cuenta" value={form.account_number} onChange={change.bind(this, "account_number")} type={"number"} error={error.account_number !== ""} helperText={error.account_number ? error.account_number : ''} inputProps={{style: { width: "100%", textAlign: "inherit" }}} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Fecha y Hora" value={form.signing_date} onChange={change.bind(this, "signing_date")} type={"datetime-local"} error={error.signing_date !== ""} helperText={error.signing_date ? error.signing_date : ''} InputLabelProps={{ shrink: true }} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Firmado por: " value={form.signed_by} onChange={change.bind(this, "signed_by")}             error={error.signed_by.length > 0} helperText={error.signed_by.length > 0 ? error.signed_by : ''} size="small" fullWidth
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton
                      title={`Agregar \nFirmante`}
                      onClick={() => form.signed_by.length > 0 ? addSigner(form.signed_by) : null}
                      edge="end"
                    >                
                      <GroupAdd/>
                    </IconButton>                
                    </InputAdornment>,
                }} />
            </Grid>
            {signed?.length > 0 && 
              <Grid item xs={12}>
                <hr style={{margin: "6px 0 14px 0"}}/>
                <p style={{padding: "0px"}}>Firmantes en el contrato:</p>
                <FireNav disablePadding>
                  <List >
                  {signed?.map((i) => {
                    return <ListItem style={{fontStyle: "oblique", color: "#969BA0"}} key={i}><Close titleAccess={`Eliminar \nFirmante`} onClick={() => deleteSigner(i)} cursor={"pointer"}/><ListItemText primary={i} /></ListItem>
                  })}
                  </List>
                </FireNav>
              </Grid>
            }
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={create.bind(this)} >Registrar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  );
};

export default AssignAgreement;
